import {useMemo} from 'react';
import {Connection} from './useConnections';

export const useSortedConnections = (connections: Connection[]) => {
    return useMemo(() => 
        [...connections].sort((a,b) => {
            const dateA = a.lastMessageAt ? new Date(a.lastMessageAt).getTime() : 0;
            const dateB = b.lastMessageAt ? new Date(b.lastMessageAt).getTime() : 0;
            return dateB - dateA;
       }), 
       [connections]
    );
};